import './TituloSessao.css';
import PropTypes from 'prop-types';

function TituloSessao({titulo, barraDecorativa, tituloAlignStart}) {

    let alinhamento = ''

    if (tituloAlignStart){
        alinhamento='start'
    } else {
        alinhamento='center'
    }

    return (
        <div className='tituloSessaoContainer p-3' style={{ display: 'flex', justifyContent: alinhamento }}>
            
            {barraDecorativa === false ? (
                <h1 className='tituloSessao m-0'>{titulo}</h1>
            ) : (
                <>
                    <span className='titleSeparator'>" "</span><h1 className='tituloSessao m-0'>{titulo}</h1>
                </>
            )}
        </div>
    );
}

TituloSessao.propTypes = {
    barraDecorativa: PropTypes.bool.isRequired,
    titulo: PropTypes.string.isRequired,
    centralizaTitulo: PropTypes.bool
};


export default TituloSessao;
